<h2 mat-dialog-title>{{header}}</h2>
<hr/>
<mat-dialog-content><p>{{message}}</p></mat-dialog-content>
<mat-dialog-actions *ngIf="isOk()">
        <button mat-button (click)="close()" [mat-dialog-close]="true">Ok</button>       
    </mat-dialog-actions>
<mat-dialog-actions *ngIf="isYesNo()">
    <button mat-button (click)="close()" [mat-dialog-close]="true">Ja</button>
    <button mat-button (click)="cancel()" [mat-dialog-close]="false">Nee</button>
</mat-dialog-actions>